import { render, staticRenderFns } from "./sale_area.vue?vue&type=template&id=581a9700&scoped=true"
import script from "./sale_area.vue?vue&type=script&lang=js"
export * from "./sale_area.vue?vue&type=script&lang=js"
import style0 from "./sale_area.vue?vue&type=style&index=0&id=581a9700&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581a9700",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('581a9700')) {
      api.createRecord('581a9700', component.options)
    } else {
      api.reload('581a9700', component.options)
    }
    module.hot.accept("./sale_area.vue?vue&type=template&id=581a9700&scoped=true", function () {
      api.rerender('581a9700', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/customer_information/components/sale_area/sale_area.vue"
export default component.exports